/** @format */
export enum AccountType {
	GUEST = 'guest',
	REGISTERED = 'loyalty'
}
